import { useState } from "react";

import { Layout, Row, Col } from "antd-v4";

import HeaderHorizontal from "./components/header/HeaderHorizontal";
import MenuFooter from "./components/footer";
import ScrollTop from "./components/scroll-to-top";

import { useCustomise } from "../context/customiseContext";

export default function HorizontalLayout(props) {
  const { children } = props;
  const [visible, setVisible] = useState(false);

  const { navigationBg, contentWidth } = useCustomise();

  return (
    <Layout className={`hp-app-layout hp-bg-color-black-20 hp-bg-color-dark-90 ${navigationBg && 'hp-app-layout-bg'}`}>
      <HeaderHorizontal visible={visible} setVisible={setVisible} />

      <Layout.Content className="hp-content-main">
        <Row justify="center">
          {
            contentWidth === "full" && (
              <Col xxl={17} xl={22} span={24}>
                {children}
              </Col>
            )
          }

          {
            contentWidth === "boxed" && (
              <Col className="hp-w-100" style={{ maxWidth: 936 }}>
                {children}
              </Col>
            )
          }
        </Row>
      </Layout.Content>

      <MenuFooter />

      <ScrollTop />
    </Layout>
  );
}
